import 'normalize.css'
import './index.css'
import App from './App'
import { Provider } from 'react-redux'
import store from './store'
import 'moment/locale/ru'
import moment from 'moment'
import axios from 'axios'
import { LocalStorage } from './utils/localStorage'
import { Provider as JotaiProvider } from 'jotai'
import { BrowserRouter } from 'react-router-dom'
import { createRoot } from 'react-dom/client'

moment.locale('ru')

const googleToken = LocalStorage.getGoogleToken()

if (googleToken) {
  axios.defaults.headers.common = { Authorization: `Bearer ${googleToken}` }
}

const container = document.getElementById('root')
const root = createRoot(container!) // createRoot(container!) if you use TypeScript
root.render(
  <JotaiProvider>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </JotaiProvider>,
)
